import AService from '@/services/AService'

const ENTITY_NAME = 'offices';

export default class OfficeService extends AService {
  async fetchOffice(id) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/${id}`);
    return response.data;
  }

  async getAll(params) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/`, {params})
    return response.data;
  }

  async toggleEnabled(office, value) {
    const response = await this.http.put(`${this.baseUrl}/${ENTITY_NAME}/toggleEnabled/${office.id}/${value}`)
    return response.data;
  }

  async create(office){
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}`, office)
    return response.data;
  }

  async update(office){
    const response = await this.http.put(`${this.baseUrl}/${ENTITY_NAME}`, office)
    return response.data;
  }

  async delete(office) {
    const response = await this.http.delete(`${this.baseUrl}/${ENTITY_NAME}/${office.id}`)
    return response.data;
  }

}
